<template>
  <section>
    <div v-animation:left class="amp__cube amp__cube--left" aria-label="Декор куб слева"></div>
    <div v-animation:right class="amp__cube amp__cube--right" aria-label="Декор куб справа"></div>
    <div class="amp-form" v-animation:bottom.delay>
      <p class="amp-form__title">Вход в конференцию</p>
      <p class="amp-form__subtitle">Пожалуйста, введите e-mail, указанный при регистрации</p>
      <label class="amp-form__field">
        <span class="amp-form__field-label">E-mail <span class="amp-form__field-label-mark">*</span></span>
        <input type="text" v-model="email" placeholder="Введите e-mail" class="amp-form__field-input" />
      </label>
      <p v-if="error" class="amp-form__error">
        <template v-if="error === 'Что-то пошло не так'">
          Если проблема сохраняется, напишите на почту
          <a href="mailto:aosupport@axoftglobal.ru">aosupport@axoftglobal.ru</a>
        </template>
        <template v-else>
          {{ error }}
        </template>
      </p>
      <div class="amp-form__btn t-btn _green _big" @click="checkAccess">Войти</div>
    </div>
  </section>
</template>

<script>
import { observeNewAnimateBlocks } from '@shared/utils/animate//scroll.animate'

export default {
  name: 'amp',
  data() {
    return {
      error: null,
      email: null,
    }
  },
  mounted() {
    setTimeout(() => {
      observeNewAnimateBlocks()
    }, 1100)
  },
  methods: {
    checkAccess() {
      this.error = 'Мероприятие Axoft Maximum PRO завершено'
    },
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

$card: #ffffff
$ink: #0f172a
$accent: #1AB8C4
$border: #e5e7eb
$radius: 6px

.t-page_axoft-max-pro
  display: flex
  align-items: center
  justify-content: center
  min-height: 100%
  background: $dark-blue
  padding-block: 130px 121px

@keyframes spin-cube
  from
    transform: rotate(0deg)
  to
    transform: rotate(360deg)

.amp
  $row-gap: 42px

  position: relative
  color: $ink

  &__cube
    position: absolute
    width: 197px
    height: 197px
    background-repeat: no-repeat
    background-size: cover
    z-index: 10

    &:hover
      animation-name: spin-cube
      animation-duration: 5000ms
      animation-iteration-count: infinite
      animation-timing-function: linear

    &--left
      top: 40%
      left: -70px
      background-image: url("/dist/img/cube.png")

    &--right
      bottom: 15%
      right: -40px
      background-image: url("/dist/img/cube_2.png")

  &__stage
    margin-top: 34px
    margin-bottom: $row-gap
    display: flex
    justify-content: center
    margin-inline: 10px

  &__card
    display: flex
    gap: 20px
    flex-direction: column
    border-radius: 6px
    background-color: #FFFFFF
    max-width: 700px
    margin-inline: 10px
    padding: 60px 40px

    @media (max-width: $tablet-size)
      padding: 20px

    > p
      font-size: 18px

/* ====== ADAPTIVE ====== */

@media (max-width: $tablet-header)
  .t-page_axoft-maximum-pro
    padding-block-start: 80px

@media (max-width: $tablet-size)
  .amp__stage
    margin-top: 25px
    margin-bottom: 25px

@media (max-width: $mobile-size)
  .t-page_axoft-maximum-pro
    padding-top: 80px

  .amp__cube, .hero__right
    display: none

// FORM

.amp-form
  display: flex
  flex-direction: column
  max-width: 424px
  background-color: #FFFFFF
  border-radius: 6px
  padding: 32px
  margin-inline: 15px

  &__wrapper
    position: relative
    margin-inline: 15px
    display: flex
    width: 100%
    align-items: center
    justify-content: center

  &__title
    font-weight: 600
    font-size: 26px
    line-height: 1.55
    color: #1E253B

  &__subtitle
    font-size: 14px
    line-height: 1.5
    color: #9FA2AC
    margin-top: 16px

  &__field
    margin-top: 32px

    &-label
      display: inline-block
      margin-bottom: 8px
      font-size: 12px
      line-height: 130%
      color: #1E253B

      &-mark
        margin-left: 6px
        color: #D65663

    &-input
      padding: 12px 24px
      background-color: transparent
      border-radius: 6px
      border: 1px solid #E7E7E8
      color: #1E253B
      width: 100%
      font-size: 14px
      line-height: 1.4
      display: block

  &__error
    margin-block: 12px 5px
    font-size: 14px
    line-height: 1.5
    color: #EC7C7C

    &-mail
      transition: color .2s
      &:hover
        color: #00b0bd

  &__btn
    margin-top: 36px
    width: 100%
    align-self: center
</style>



// WEBPACK FOOTER //
// src/templates/pages/axoft-maximum-pro/index.vue